import { ArrowLeft } from "lucide-react";
import { BottomNav } from "./BottomNav";

export function PublicLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: React.ReactNode }) {
  const isHome = window.location.pathname === "/";
  return (
    <div className="front-stage">
      <main className="app-shell">
        {!isHome && (
          <a className="back-link" href="/">
            <ArrowLeft size={18} /> 返回龍來喬大廳
          </a>
        )}
        {!isHome ? (
          <header className="page-header">
            <span className="hero-kicker">龍來喬</span>
            <h1>{title}</h1>
            {subtitle ? <p>{subtitle}</p> : null}
          </header>
        ) : null}
        {children}
        <BottomNav />
      </main>
    </div>
  );
}
